// ============================================================================
// UNCLAIMED QUEUE WIDGET — Phase 8.D
// ============================================================================
// Shared pool of UNCLAIMED litigation cases, ordered oldest-first so the
// officer picks the most-aged case. Clicking a row opens the case-detail
// modal where the officer can fire the Claim action.

import React from 'react';
import IconSystem from 'icon-collection/icon-systems';
import { useUnclaimedQueue } from 'hooks/api/useRecoveryDashboard';
import { openLitigationCase } from 'components/modules/litigation-module/openLitigationCase';

interface Props { refreshKey?: number; }

const UnclaimedQueueWidget: React.FC<Props> = ({ refreshKey }) => {
  const { data, loading } = useUnclaimedQueue(10, refreshKey);

  return (
    <div className="dashboard-widget">
      <div className="dashboard-widget-header">
        <h3 className="dashboard-widget-title">
          <IconSystem.list size={18} />
          Unclaimed Queue
        </h3>
        <span className="dashboard-kpi-chip">{data.length}</span>
      </div>
      <div className="dashboard-widget-subtitle">
        Cases waiting to be picked &mdash; oldest first
      </div>
      <div className="dashboard-widget-body">
        {loading ? (
          <div className="dashboard-widget-loading">Loading...</div>
        ) : data.length === 0 ? (
          <div className="dashboard-widget-empty">No unclaimed cases.</div>
        ) : (
          data.map(item => (
            <div key={item.caseId} className="dashboard-list-row">
              <div className="dashboard-list-row-main">
                <span className="dashboard-list-row-title">
                  {item.borrowerName || '—'} <span style={{ color: 'var(--text-muted)', fontWeight: 400 }}>· {item.caseCode}</span>
                </span>
                <span className="dashboard-list-row-meta">
                  {item.caseTypeDisplayName || item.caseTypeCode} · {item.accountNumber || '—'} · {item.ageDays}d old · DPD {item.openedDpd}
                </span>
              </div>
              <button
                type="button"
                className="dashboard-row-action"
                onClick={() => openLitigationCase(item.caseId)}
              >
                Open
              </button>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default UnclaimedQueueWidget;
